const moduleHome = {
	namespaced: true,
	state: {
		CUR_PAGENUM: parseInt(sessionStorage.getItem('pagenum')) || 1,
		CUR_TAG: JSON.parse(sessionStorage.getItem('tag')),
		CUR_SEASON: sessionStorage.getItem('season'),
		CUR_CHECKPOINT: sessionStorage.getItem('checkpoint'),
    CUR_SEL_DIFFICULTY: sessionStorage.getItem('sel_difficulty'),
    CUR_OPERATORNAME_INCLUDE: JSON.parse(sessionStorage.getItem('operator_name_include')),
    CUR_OPERATORNAME_UNINCLUDE: JSON.parse(sessionStorage.getItem('operator_name_uninclude')),

		CUR_CHECKPOINT_TIME_INDEX: sessionStorage.getItem(
			'checkpoint_time_index'
		),
		CUR_CONTRACTLIST: JSON.parse(sessionStorage.getItem('contract_list')),

    CUR_SORTTYPE: parseInt(sessionStorage.getItem('sorttype')), // 排序方式
    DEFAULT_SORTTYPE: parseInt(sessionStorage.getItem('default_sorttype')),   // 默认排序 方式
		CUR_RANDOM_LIST: JSON.parse(sessionStorage.getItem('randomlist')) || '', // 随机列表数据
	},
	mutations: {
		SET_CUR_PAGENUM: (state, params) => {
			state.CUR_PAGENUM = params
			sessionStorage.setItem('pagenum', params)
		},
		SET_CUR_TAG: (state, params) => {
			state.CUR_TAG = params
			sessionStorage.setItem('tag', JSON.stringify(params))
		},
		SET_CUR_SEASON: (state, params) => {
			state.CUR_SEASON = params
			sessionStorage.setItem('season', params)
		},
		SET_CUR_CHECKPOINT: (state, params) => {
			state.CUR_CHECKPOINT = params
			sessionStorage.setItem('checkpoint', params)
		},
		SET_CUR_SEL_DIFFICULTY: (state, params) => {
			state.CUR_SEL_DIFFICULTY = params
			sessionStorage.setItem('sel_difficulty', params)
		},
		SET_CUR_OPERATORNAME_INCLUDE: (state, params) => {
      state.CUR_OPERATORNAME_INCLUDE = params
			sessionStorage.setItem('operator_name_include', JSON.stringify(params))
    },
    SET_CUR_OPERATORNAME_UNINCLUDE: (state, params) => {
      state.CUR_OPERATORNAME_UNINCLUDE = params
			sessionStorage.setItem('operator_name_uninclude', JSON.stringify(params))
    },
		SET_CUR_CHECKPOINT_TIME_INDEX: (state, params) => {
			state.CUR_CHECKPOINT_TIME_INDEX = params
			sessionStorage.setItem('checkpoint_time_index', params)
		},
		SET_CUR_CONTRACTLIST: (state, params) => {
			state.CUR_CONTRACTLIST = params
			sessionStorage.setItem('contract_list', JSON.stringify(params))
		},
		SET_CUR_SORTTYPE: (state, params) => {
			state.CUR_SORTTYPE = params
			sessionStorage.setItem('sorttype', params)
    },
    SET_DEFAULT_SORTTYPE: (state, params) => {
      state.DEFAULT_SORTTYPE = params
      sessionStorage.setItem("default_sorttype", params)
    },
		SET_CUR_RANDOM_LIST: (state, params) => {
			state.CUR_RANDOM_LIST = params
			sessionStorage.setItem('randomlist', JSON.stringify(params))
		},
	},
	actions: {
		clearFilter({ commit }) {
			commit('SET_CUR_PAGENUM', 1)
      commit('SET_CUR_TAG', [])
      commit('SET_CUR_SEASON', "")
      commit("SET_CUR_CHECKPOINT", "")
			commit("SET_CUR_SEL_DIFFICULTY", "")
      commit("SET_CUR_OPERATORNAME_INCLUDE", [])
      commit("SET_CUR_OPERATORNAME_UNINCLUDE", [])
      commit("SET_CUR_CHECKPOINT_TIME_INDEX", "")
      commit("SET_CUR_CONTRACTLIST", [])
      commit("SET_CUR_SORTTYPE", this.state.Home.DEFAULT_SORTTYPE)
		},
		clearRandomList({ commit }) {
			commit('SET_CUR_RANDOM_LIST', null)
		},
	},
	getters: {},
}

export default moduleHome
